import type { dashboards as en } from "../en/dashboards";
import type { Messages } from "../types";

export const dashboards: Messages<typeof en> = {
  title: "لوحات المتابعة",
  subtitle: "لوحات حيّة مبنية من بياناتك، وكل أداة فيها تتحدّث تلقائيًا.",
  newDashboard: "لوحة جديدة",
  loading: "جارٍ تحميل اللوحة",
  empty: {
    title: "لا توجد لوحات بعد",
    hint: "ابدأ من قالب أو من لوحة فارغة.",
    widgets: "هذه اللوحة فارغة",
    widgetsHint: "أضف أداة من المعرض أو ابنِ أداتك الخاصة من أي مجموعة بيانات.",
  },
  calm: {
    yours: "لوحاتك",
    accounts: "لوحات الحسابات",
    accountsHint: "لوحة متابعة مباشرة لكل حساب إنستغرام مربوط.",
    accountNew: "جاهزة للفتح",
    seeAnalytics: "عرض تحليلات إنستغرام",
    emptyHint: "أنشئ لوحة من القوالب، أو ابدأ بتحليلات إنستغرام.",
  },
  list: {
    widgets_zero: "الأدوات: {{count}}",
    widgets_one: "الأدوات: {{count}}",
    widgets_two: "الأدوات: {{count}}",
    widgets_few: "الأدوات: {{count}}",
    widgets_many: "الأدوات: {{count}}",
    widgets_other: "الأدوات: {{count}}",
    team: "للفريق",
    private: "خاصة",
    default: "الافتراضية",
    open: "فتح",
    delete: "حذف اللوحة",
    deleteConfirm: "حذف «\u2068{{name}}\u2069»؟",
    deleteHint: "ستُحذف عناصرها لكل من تمت مشاركتها معه.",
    deleted: "تم حذف اللوحة",
    updated: "حُدّثت {{ago}}",
    scopes: { org: "المؤسسة", account: "حساب", post: "منشور", campaign: "حملة" },
  },
  create: {
    title: "لوحة جديدة",
    name: "الاسم",
    namePlaceholder: "مثلاً: حملة رمضان",
    template: "ابدأ من",
    blank: "لوحة فارغة",
    blankHint: "أضف الأدوات واحدة تلو الأخرى.",
    shared: "مشاركة مع الفريق",
    sharedHint: "يستطيع زملاؤك مشاهدتها، والمحررون تعديلها.",
    create: "إنشاء اللوحة",
    created: "تم إنشاء اللوحة",
  },
  templates: {
    home: "الرئيسية",
    homeHint: "الوصول والتعليقات والمشاعر والأتمتة وأفضل المنشورات.",
    account: "الحساب",
    accountHint: "جمهور حساب واحد ونشاطه ومحتواه.",
    post: "المنشور",
    postHint: "أداء منشور واحد وتعليقاته وأتمتته.",
    campaign: "الحملة",
    campaignHint: "مجموعة منشورات جنباً إلى جنب.",
  },
  toolbar: {
    edit: "تعديل اللوحة",
    done: "تم",
    add: "إضافة أداة",
    reset: "إعادة إلى القالب",
    resetConfirm: "إعادة هذه اللوحة؟",
    resetHint: "ستعود الأدوات والتصفية إلى القالب وتضيع تعديلاتك.",
    resetDone: "تمت إعادة اللوحة",
    shareTeam: "مشاركة مع الفريق",
    sharePrivate: "جعلها خاصة",
    shared: "تمت المشاركة مع الفريق",
    privateNow: "أنت فقط من يراها الآن",
    makeDefault: "تعيين كافتراضية",
    defaultSet: "أصبحت هذه اللوحة الافتراضية",
    rename: "إعادة تسمية اللوحة",
    more: "خيارات اللوحة",
    viewOnly: "للعرض فقط",
    editing: "وضع التعديل: اسحب الأدوات من عنوانها، وغيّر حجمها من الزاوية.",
    allDashboards: "كل اللوحات",
  },
  filters: {
    label: "فلاتر اللوحة",
    time: "الفترة الزمنية",
    compare: "مقارنة",
    compareHint: "مقارنة بالفترة السابقة",
    compareAllTime: "لا توجد فترة سابقة لكل الوقت",
    accounts: "الحسابات",
    channels: "القنوات",
    sentiment: "المشاعر",
    intent: "النية",
    posts: "المنشورات",
    searchPosts: "ابحث في المنشورات",
    noPosts: "لا منشورات مطابقة",
    any: "الكل",
    clear: "مسح التصفية",
    selected_zero: "المحدد: {{count}}",
    selected_one: "المحدد: {{count}}",
    selected_two: "المحدد: {{count}}",
    selected_few: "المحدد: {{count}}",
    selected_many: "المحدد: {{count}}",
    selected_other: "المحدد: {{count}}",
    removeFilter: "إزالة التصفية {{label}}",
    from: "من",
    to: "إلى",
    apply: "تطبيق",
    tags: "الوسوم",
    searchTags: "ابحث في الوسوم",
    noTags: "لا توجد وسوم مطابقة",
    category: "فئة ذكاء اصطناعي",
    builtIn: "وسم مدمج",
    customTag: "وسمك",
    presets: {
      today: "اليوم",
      "24h": "آخر 24 ساعة",
      "7d": "آخر 7 أيام",
      "30d": "آخر 30 يوماً",
      "90d": "آخر 90 يوماً",
      mtd: "منذ بداية الشهر",
      ytd: "منذ بداية السنة",
      all: "كل الوقت",
      custom: "فترة مخصصة",
    },
  },
  widget: {
    updated: "حُدّث {{ago}}",
    updatedNow: "حُدّث للتو",
    live: "مباشر",
    refreshing: "جارٍ التحديث",
    refresh: "تحديث",
    menu: "خيارات {{title}}",
    edit: "تعديل",
    duplicate: "تكرار",
    duplicated: "تم تكرار الأداة",
    fullscreen: "ملء الشاشة",
    exportPng: "تصدير كصورة PNG",
    exportCsv: "تصدير كملف CSV",
    delete: "إزالة",
    deleted: "تمت إزالة «\u2068{{title}}\u2069»",
    undo: "تراجع",
    restored: "تمت استعادة الأداة",
    noData: "لا توجد بيانات في هذه الفترة",
    error: "تعذّر تحميل هذه الأداة",
    retry: "إعادة المحاولة",
    ignored: "غير مفلتر حسب {{list}}",
    vsPrevious: "مقارنة بالفترة السابقة",
    noPrevious: "لا بيانات سابقة",
    titleLabel: "عنوان الأداة",
    drill: "انقر على نقطة لرؤية عناصرها",
    grab: "تحريك أو تغيير حجم {{title}}",
    keyboardHint: "الأسهم تحرّك الأداة، وShift مع الأسهم يغيّر حجمها، وEscape للإنهاء.",
    moved: "نُقل إلى العمود {{x}}، الصف {{y}}",
    resized: "أصبح الحجم \u2066{{w}} × {{h}}\u2069",
    other: "أخرى",
    truncated_zero: "تُعرض أول {{count}} صف",
    truncated_one: "يُعرض الصف الأول فقط",
    truncated_two: "تُعرض أول صفّين",
    truncated_few: "تُعرض أول {{count}} صفوف",
    truncated_many: "تُعرض أول {{count}} صفًا",
    truncated_other: "تُعرض أول {{count}} صف",
    total: "الإجمالي",
    goal: "الهدف {{value}}",
    open: "فتح",
    exportFailed: "تعذّر التصدير",
  },
  editor: {
    addTitle: "إضافة أداة",
    editTitle: "تعديل الأداة",
    gallery: "المعرض",
    custom: "ابنِ أداتك",
    dataset: "البيانات",
    measures: "المقاييس",
    addMeasure: "إضافة مقياس",
    groupBy: "التجميع حسب",
    addGroup: "إضافة تجميع",
    filters: "التصفية",
    addFilter: "إضافة فلتر",
    viz: "طريقة العرض",
    options: "الخيارات",
    preview: "معاينة مباشرة",
    title: "العنوان",
    subtitle: "عنوان فرعي (اختياري)",
    fn: "الدالة",
    field: "الحقل",
    alias: "اسم العمود",
    granularity: "الفترة",
    op: "الشرط",
    value: "القيمة",
    where: "فقط الصفوف التي",
    format: "تنسيق الأرقام",
    legend: "إظهار مفتاح الألوان",
    stacked: "تكديس السلاسل",
    showCompare: "إظهار الفترة السابقة",
    topN: "عدد الصفوف",
    color: "اللون",
    text: "النص (Markdown)",
    refresh: "التحديث",
    inherit: "استخدام فلاتر اللوحة",
    inheritHint: "تنطبق الفترة الزمنية والتصفية من الشريط أعلاه على هذه الأداة.",
    save: "حفظ الأداة",
    add: "إضافة إلى اللوحة",
    added: "تمت إضافة الأداة",
    saved: "تم حفظ الأداة",
    cancel: "إلغاء",
    remove: "إزالة",
    records: "عناصر (بلا مقاييس): قوائم وجداول بالعناصر نفسها",
    noMeasure: "بلا مقاييس: تعرض الأداة قائمة بالعناصر الفردية.",
    allFields: "كل الحقول",
    pickTemplate: "اختر نقطة البداية",
    yes: "نعم",
    no: "لا",
    fns: { count: "العدد", sum: "المجموع", avg: "المتوسط", min: "الأدنى", max: "الأعلى", p95: "المئين 95", rate: "نسبة الصفوف", distinct: "عدد القيم المختلفة" },
    ops: { eq: "يساوي", neq: "لا يساوي", in: "أحد", nin: "ليس أحد", gt: "أكبر من", gte: "على الأقل", lt: "أصغر من", lte: "على الأكثر", contains: "يحتوي", semantic: "يتحدث عن" },
    granularities: { hour: "ساعة", day: "يوم", week: "أسبوع", month: "شهر", hour_of_day: "ساعة من اليوم", day_of_week: "يوم من الأسبوع" },
    refreshModes: { live: "مباشر (عند تغيّر البيانات)", "30s": "كل 30 ثانية", "1m": "كل دقيقة", "5m": "كل 5 دقائق", manual: "يدوياً" },
    formats: { number: "رقم", compact: "مختصر (12.4K)", percent: "نسبة مئوية", currency: "عملة", duration: "مدة" },
    categories: { all: "الكل", engagement: "التفاعل", audience: "الجمهور", inbox: "صندوق الوارد", automation: "الأتمتة", content: "المحتوى", operations: "العمليات" },
  },
  actions: {
    segmentLabel: "إجراءات لـ {{label}}",
    createRule: "إنشاء قاعدة من هذا",
    apply: "تطبيق إجراء على هذه العناصر",
    closeSegment: "إغلاق الإجراءات",
    ruleTitle: "إنشاء قاعدة من هذا",
    ruleHint: "قاعدة تعمل على العناصر الجديدة مثل «{{label}}». راجعها في منشئ القواعد قبل تشغيلها.",
    cancel: "إلغاء",
    openBuilder: "فتح في منشئ القواعد",
    mapped: "تصبح شروط القاعدة",
    nothingMapped: "لم يتحول أي فلتر إلى شرط: ستطابق القاعدة كل عنصر جديد حتى تضيف شروطاً.",
    unmapped: "غير مضمّن",
    unmappedHint: "تعمل القواعد على كل تعليق أو رسالة جديدة لحظة وصولها، لذا لا يمكن أن تكون الفترات الزمنية والحالات والأرقام جزءاً منها.",
    ruleInactive: "تُفتح القاعدة متوقفة وبوضع «الموافقة»، مع إجراء وسم يمكنك تغييره.",
    applyTitle: "تطبيق إجراء على هذه العناصر",
    review: "مراجعة",
    itemsLabel: "العناصر المطابقة",
    count: "يطابق {{what}}",
    countCapped: "يطابق {{what}} · يُطبّق الإجراء على أحدث {{n}}",
    comments: "{{n}} من التعليقات",
    conversations: "{{n}} من المحادثات",
    pick: "ماذا يحدث؟",
    kinds: { flag: "وسم", hide: "إخفاء", unhide: "إظهار", archive: "أرشفة", unarchive: "إلغاء الأرشفة", reply_with_agent: "الرد بوكيل ذكي", assign: "إسناد" },
    hints: {
      flag: "أضف أو أزل الوسوم والفئات الذكية.",
      hide: "إخفاء التعليقات على إنستغرام (قابل للتراجع).",
      unhide: "إظهار التعليقات المخفية مجدداً.",
      archive: "إخراجها من صندوق الوارد (قابل للتراجع).",
      unarchive: "إعادة التعليقات المؤرشفة.",
      reply_with_agent: "يصوغ وكيل ذكي رداً لكل عنصر؛ تنتظر المسودات الموافقة.",
      assign: "إسنادها إلى عضو في الفريق.",
    },
    titles: {
      flag: "وسم {{what}}",
      unflag: "إزالة وسوم من {{what}}",
      hide: "إخفاء {{what}}",
      unhide: "إظهار {{what}}",
      archive: "أرشفة {{what}}",
      unarchive: "إلغاء أرشفة {{what}}",
      reply_with_agent: "صياغة ردود على {{what}} بواسطة {{agent}}",
      assign: "إسناد {{what}} إلى {{name}}",
    },
    addTags: "إضافة",
    removeTags: "إزالة",
    pickAgent: "اختر وكيلاً",
    agentHint: "كل مسودة موافقة معلّقة؛ لا يُرسل شيء قبل أن يوافق عليها أحد.",
    pickMember: "اختر عضواً في الفريق",
  },
  viz: { kpi: "مؤشر", line: "خطي", area: "مساحي", bar: "أعمدة", stacked_bar: "أعمدة مكدّسة", donut: "دائري", heatmap: "خريطة حرارية", table: "جدول", funnel: "قمع", comments: "قائمة تعليقات", posts: "شبكة منشورات", text: "نص" },
  drill: {
    title: "العناصر خلف «\u2068{{label}}\u2069»",
    hint: "العناصر التي تكوّن هذه النقطة. افتح أحدها للتعامل معه.",
    open: "فتح",
    empty: "لا عناصر",
  },
  scoped: {
    accountTitle: "لوحة {{account}}",
    accountHint: "رسوم حيّة لهذا الحساب فقط.",
    postTitle: "لوحة المنشور",
    postHint: "رسوم حيّة لهذا المنشور. فعّل وضع التعديل لإضافة الأدوات أو إزالتها أو تغيير حجمها.",
    openAccount: "لوحة الحساب",
    openPost: "فتح اللوحة",
    notFound: "هذا الحساب لم يعد متصلاً",
  },
  datasets: {
    comments: "التعليقات",
    messages: "الرسائل المباشرة",
    conversations: "المحادثات",
    posts: "المنشورات",
    post_insights: "إحصاءات المنشورات",
    post_metrics: "مقاييس المنشورات عبر الزمن",
    account_insights: "إحصاءات الحساب",
    automation_runs: "عمليات الأتمتة",
    ai_usage: "استخدام الذكاء الاصطناعي",
    jobs: "المهام",
  },
  fields: {
    comments: {
      id: "التعليق", text: "النص", author: "الكاتب", contact_id: "جهة الاتصال", account_id: "الحساب", post_id: "المنشور", publication_id: "النشر", channel: "القناة", status: "الحالة",
      inbox_state: "حالة الوارد", sentiment: "المشاعر", intent: "النية", language: "اللغة", toxicity: "السمّية", confidence: "ثقة الذكاء الاصطناعي", replies_count: "الردود",
      replied: "ردّ عليه الحساب", response_minutes: "زمن الرد (دقيقة)", is_reply: "ردّ على تعليق", by_account: "كتبه الحساب", assigned: "مُسند", assignee_id: "المسؤول", created_at: "التاريخ",
      tag: "الوسم", tagged_by_rule: "وسمته القاعدة",
    },
    messages: { id: "الرسالة", conversation_id: "المحادثة", account_id: "الحساب", channel: "القناة", direction: "الاتجاه", sent_by: "المرسل", status: "الحالة", has_attachment: "فيها مرفق", text: "النص", tag: "وسم المحادثة", sent_at: "وقت الإرسال" },
    conversations: {
      id: "المحادثة", account_id: "الحساب", contact_id: "جهة الاتصال", channel: "القناة", inbox_state: "حالة الوارد", sentiment: "المشاعر", intent: "النية", unread: "غير مقروءة",
      ai_agent: "وكيل الذكاء الاصطناعي مفعّل", window_open: "نافذة 24 ساعة مفتوحة", assigned: "مُسندة", assignee_id: "المسؤول", last_message_at: "آخر رسالة",
      tag: "الوسم", tagged_by_rule: "وسمته القاعدة",
    },
    posts: {
      id: "النشر", post_id: "المنشور", account_id: "الحساب", channel: "القناة", type: "النوع", status: "الحالة", caption: "النص", permalink: "الرابط", media_url: "الوسائط",
      imported: "مستورد", comments_count: "التعليقات", likes_count: "الإعجابات", published_at: "تاريخ النشر", scheduled_at: "موعد الجدولة",
    },
    post_insights: {
      post_id: "المنشور", publication_id: "النشر", account_id: "الحساب", channel: "القناة", type: "النوع", reach: "الوصول", views: "المشاهدات", saves: "الحفظ", shares: "المشاركات",
      likes: "الإعجابات", comments: "التعليقات", interactions: "التفاعلات", engagement_rate: "معدل التفاعل", published_at: "تاريخ النشر",
    },
    post_metrics: { post_id: "المنشور", publication_id: "النشر", account_id: "الحساب", reach: "الوصول", views: "المشاهدات", likes: "الإعجابات", saves: "الحفظ", shares: "المشاركات", comments: "التعليقات", day: "اليوم" },
    account_insights: {
      account_id: "الحساب", reach: "الوصول", views: "المشاهدات", accounts_engaged: "الحسابات المتفاعلة", total_interactions: "التفاعلات", likes: "الإعجابات", comments: "التعليقات",
      shares: "المشاركات", saves: "الحفظ", profile_views: "زيارات الملف", followers: "المتابعون", day: "اليوم",
    },
    automation_runs: { id: "العملية", rule_id: "القاعدة", account_id: "الحساب", post_id: "المنشور", comment_id: "التعليق", matched: "مطابقة", action: "الإجراء", result: "النتيجة", sentiment: "المشاعر", intent: "النية", created_at: "التاريخ" },
    ai_usage: { kind: "النوع", model: "النموذج", feature: "الميزة", qty: "الكمية", at: "الوقت" },
    jobs: { id: "المهمة", kind: "النوع", status: "الحالة", done: "المنجز", total: "الإجمالي", failed: "الفاشل", duration_sec: "المدة (ثانية)", created_by: "بدأها", created_at: "التاريخ", finished_at: "الانتهاء" },
  },
  measureNames: {
    comments: "التعليقات", negative_rate: "نسبة السلبية", reply_rate: "معدل الرد", response_minutes: "زمن الرد", handled: "المنجز", evaluated: "المُقيّم", matched: "المطابق",
    executed: "المنفّذ", runs: "العمليات", messages: "الرسائل", open: "المفتوحة", jobs: "المهام", tokens: "الرموز", count_all: "العدد", reach: "الوصول", views: "المشاهدات", likes: "الإعجابات",
    saves: "الحفظ", followers: "المتابعون", engagement_rate: "معدل التفاعل",
  },
  values: {
    status: { visible: "ظاهر", hidden: "مخفي", deleted: "محذوف", received: "مستلمة", sending: "قيد الإرسال", sent: "مرسلة", delivered: "تم التسليم", read: "مقروءة", failed: "فشل", draft: "مسودة", scheduled: "مجدول", publishing: "قيد النشر", published: "منشور", cancelled: "ملغى", queued: "في الانتظار", running: "قيد التنفيذ", paused: "متوقف مؤقتاً", succeeded: "نجح" },
    direction: { in: "واردة", out: "صادرة" },
    sent_by: { contact: "جهة الاتصال", user: "الفريق", automation: "الأتمتة", ai: "الذكاء الاصطناعي" },
    result: { executed: "نُفّذ", pending_approval: "بانتظار الموافقة", skipped: "تم التخطي", failed: "فشل", suggested: "مقترح" },
  },
  wt: {
    kpi_post_reach: { title: "وصول المنشورات", description: "الوصول الكلي للمنشورات في الفترة." },
    kpi_reach: { title: "الوصول", description: "الحسابات التي وصلها المحتوى (إحصاءات يومية)." },
    kpi_comments: { title: "التعليقات", description: "التعليقات الواردة مقارنة بالفترة السابقة." },
    kpi_negative_rate: { title: "نسبة السلبية", description: "نسبة التعليقات ذات المشاعر السلبية." },
    kpi_automation: { title: "أنجزتها الأتمتة", description: "مطابقات القواعد التي نفّذت إجراءً." },
    comments_over_time: { title: "التعليقات عبر الزمن", description: "التعليقات اليومية حسب المشاعر." },
    sentiment_donut: { title: "المشاعر", description: "توزيع مشاعر التعليقات. انقر على شريحة لفلترة اللوحة." },
    intent_bar: { title: "ماذا يسأل الناس", description: "التعليقات حسب النية." },
    reach_trend: { title: "الوصول والمشاهدات", description: "الوصول والمشاهدات يومياً مع الفترة السابقة." },
    activity_heatmap: { title: "متى يعلّق الناس", description: "التعليقات حسب اليوم والساعة." },
    latest_comments: { title: "أحدث التعليقات", description: "أحدث التعليقات مباشرة." },
    negative_comments: { title: "التعليقات السلبية", description: "تعليقات تحتاج عناية." },
    top_posts: { title: "أفضل المنشورات", description: "المنشورات مرتبة حسب الوصول." },
    post_metrics_trend: { title: "أداء المنشور عبر الزمن", description: "الوصول والمشاهدات والإعجابات والحفظ والتعليقات يومياً." },
    top_commenters: { title: "أكثر المعلّقين", description: "من يعلّق أكثر." },
    kpi_reply_rate: { title: "معدل الرد", description: "نسبة التعليقات التي ردّ عليها الحساب." },
    kpi_response_time: { title: "زمن الرد", description: "متوسط الدقائق حتى ردّ الحساب." },
    post_table: { title: "أداء المنشورات", description: "الوصول والمشاهدات والحفظ والتفاعل لكل منشور." },
    automation_funnel: { title: "قمع الأتمتة", description: "الأحداث ← المطابقة ← التنفيذ." },
    automation_by_rule: { title: "الإجراءات حسب القاعدة", description: "أي القواعد تنجز العمل." },
    dm_volume: { title: "الرسائل الواردة والصادرة", description: "الرسائل المستلمة والمرسلة يومياً." },
    open_conversations: { title: "المحادثات المفتوحة", description: "محادثات بانتظارك." },
    followers_trend: { title: "المتابعون", description: "عدد المتابعين عبر الزمن." },
    jobs_status: { title: "المهام", description: "العمليات الطويلة حسب الحالة." },
    ai_usage_trend: { title: "استخدام الذكاء الاصطناعي", description: "رموز الذكاء الاصطناعي يومياً." },
    comments_by_tag: { title: "التعليقات حسب الوسم", description: "التعليقات لكل وسم وفئة ذكية. انقر عموداً للتصفية." },
    tag_trend: { title: "اتجاه الوسوم عبر الزمن", description: "التعليقات الموسومة يومياً حسب الوسم." },
    top_posts_by_tag: { title: "أكثر المنشورات حسب الوسم", description: "أي المنشورات تجمع أي الوسوم." },
    tagged_by_rule: { title: "الوسوم حسب القاعدة", description: "التعليقات التي وسمتها كل قاعدة." },
    note: { title: "ملاحظة", description: "نص للسياق أو الأهداف." },
  },
};
